import { render } from "./CloseMe.vue?vue&type=template&id=7bc4c110"
import script from "./CloseMe.vue?vue&type=script&lang=js"
export * from "./CloseMe.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__